<script>
import VirtualList from 'svelte-tiny-virtual-list';
import {default as BetItem} from './item.svelte';

export let items = []

const vlistUpdate = (items) => {
    items.reverse()
    if(vlist )
        vlist.recomputeSizes(0)
} 

$: vlistUpdate(items)

let vlist 

</script>

<VirtualList
bind:this={vlist}
width="auto"
height={460}
itemCount={items.length}
itemSize={40}
getKey={ (i) =>  (items[i].iid.split(":"))[1]  }>

<div slot="item" let:index let:style {style} class="row">
    <BetItem bet={{... items[index]}}></BetItem>
</div>

</VirtualList>

<style>
   .betlistContainer {
        padding: 0;
        height: 500px;
    }
  
    :global(.virtual-list-inner) {
        box-shadow: 0px 0px 1px 1px rgb(240 240 240 / 30%);
}
    :global(.virtual-list-wrapper) {

        border-radius: 2px;
       /* box-shadow: 0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.2),0 1px 5px 0 rgba(0,0,0,.12);*/
       /* background:  #2f2f2f;*/
        font-family: -apple-system,BlinkMacSystemFont,Helvetica,Arial,sans-serif;
        color: rgb(233, 233, 233);
        -webkit-font-smoothing: antialiased;
        padding: 0.2em
    }

    .row {
        padding: 0px 6px;
    border-bottom: 1px solid #eee;
    box-sizing: border-box;
    line-height: 40px;
    font-weight: 600;
    background: #636363;
    font-family: system-ui;

background: linear-gradient(0deg,#090909 0%, #111111 80%, #262626 90%);

}
    
.row span.text {
    font-size: 1.25em;
}

    :global(.extra.massive > .diamond) {
        font-size: 2.3rem !important;
    }

    :global(.diamond) {
        border-radius: 0.3rem !important;
    }
    :global(.diamond.red) {
        background-color: #cc0000 !important;
    }
    :global(.diamond.green) {
        background-color: #00a008 !important;
    }
    :global(.diamond.purple) {
        background-color: #9e009e !important;
    }
    :global(.diamond.yellow) {
        background-color: #e9dd00 !important;
    }
    :global(.diamond.cyan) {
        background-color: #2effdc !important;
    }
    :global(.diamond.orange) {
        background-color: #ff5ca8 !important;
    }
    :global(.diamond.blue) {
        background-color: #3a00c0 !important;
    }

</style>